import React from 'react';

/**
 * DocumentsSection - List of uploaded files with download/delete actions
 */
function DocumentsSection({ files, loadingFiles, uploading, fileInputRef, onDownload, onDelete, formatFileSize }) {
  if (loadingFiles) {
    return (
      <div className="mb-5">
        <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Dokumenter</p>
        <div className="flex items-center justify-center py-4">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-cyan-500"></div>
        </div>
      </div>
    );
  }
  
  if (!files || files.length === 0) return null;
  
  return (
    <div className="mb-5" data-testid="documents-section">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">
        Opplastede dokumenter ({files.length})
      </p>
      <div className="space-y-2">
        {files.map((file) => (
          <div key={file.id} className="flex items-center justify-between p-3 bg-slate-800/50 rounded-xl group hover:bg-slate-800 transition-colors border border-slate-700/50">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <svg className="w-5 h-5 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-200 truncate">{file.original_filename}</p>
                <p className="text-xs text-slate-500">{formatFileSize(file.size)}</p>
              </div>
            </div>
            <div className="flex items-center gap-1">
              <button
                onClick={() => onDownload(file)}
                className="p-1.5 text-slate-500 hover:text-cyan-400 hover:bg-cyan-500/10 rounded-lg transition-colors"
                title="Last ned"
                data-testid={`download-file-${file.id}`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </button>
              <button
                onClick={() => onDelete(file.id)}
                className="p-1.5 text-slate-500 hover:text-rose-400 hover:bg-rose-500/10 rounded-lg transition-colors"
                title="Slett"
                data-testid={`delete-file-${file.id}`}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DocumentsSection;
